import * as Colors from "../../../../globalStyles/environmentColors";

export const body = {
    padding: "15px"
};

export const container = {
    background: Colors.primary,
    color: "white",
    padding: "30px",

    borderRadius: "25px"
};

export const topContainer = {
    textAlign: "center"
};

export const categoryHeadings = {
    textAlign: "right",
    fontSize: "1.5rem",
    margin: "auto"
};

export const dropdownText = {
    color: Colors.accent
};

export const itemsTable = {
    color: "white",
    textAlign: "center"
};

export const tableHeadings = {
    fontWeight: "bold"
};

export const totalRows = {
    color: "yellow",
    fontWeight: "bold"
};

export const tabRow = {
    padding: "15px"
};

export const tab = {
    backgroundColor: Colors.secondary,
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 0px 0px",
    borderBottom: "2px solid",
    cursor: "pointer"
};

export const m_tab = {
    backgroundColor: Colors.secondary,
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 25px 25px",
    cursor: "pointer"
};

export const selectedTab = {
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 0px 0px",
    backgroundColor: "#163172",
    color: "white",
    fontWeight: "bold",
    borderLeft: "2px solid black",
    borderRight: "2px solid black",
    borderTop: "2px solid black"
};

export const m_selectedTab = {
    textAlign: "center",
    fontSize: "1.5rem",
    borderRadius: "25px 25px 25px 25px",
    backgroundColor: "#163172",
    color: "white",
    fontWeight: "bold",
    border: "2px solid black"
};

export const tabContent = {
    backgroundColor: "white",
    minHeight: "200px",
    borderBottom: "2px solid",
    borderLeft: "2px solid",
    borderRight: "2px solid",
    paddingTop: "10px"
};

export const m_tabContent = {
    backgroundColor: "white",
    border: "2px solid",
    paddingTop: "10px"
};

export const submitBtnCol = {
    textAlign: "right"
};

export const submitBtn = {
    color: Colors.accent
};

export const submitModalTitles = {
    margin: "auto"
};

export const lengthCounter = {
    textAlign: "right",
    color: "red"
};
